import { addDays, formatDate, isValid, setHours, setMinutes, setSeconds } from "date-fns";
import { createLogger } from "logging";
import { getResourceStrict, ResourceKeys } from "providers";

import { getHoursAsNumber, getMinutesAsNumber } from "./lyneDates";

const logger = createLogger("helpers/meeting");

export function getMeetingTitle(s?: string) {
  let result = `${s}`.trim();
  result = getResourceStrict(ResourceKeys.Page_MeetingName_Title).replace("{0}", result);
  logger.trace(`getMeetingTitle(): s:=${s} -> `, result);

  return result;
}

export function getMeetingName(eventDate: Date, shortName?: string) {
  const date = formatDate(eventDate, "yyyy-MM-dd");
  const shortNameToUse = shortName?.replace(` `, "-");
  const result = `${date}_${shortNameToUse}-Sitzung`;
  logger.trace(`getMeetingName(): eventDate:=${eventDate}, shortName:=${shortName} -> `, result);

  return result;
}

export function getEventTimeOrDefault(time: string | undefined, defaultTime?: string) {
  let result = time;
  if (!result) result = defaultTime;
  if (!result) result = "09:00";
  logger.trace(`getEventTimeOrDefault(): time:=${time}, defaultTime:=${defaultTime} -> `, result);

  return result;
}

export function getEventDateOrDefault(date: Date | undefined, time: string | undefined, defaultTime?: string) {
  let result = date ? date : new Date();
  if (!isValid(result)) {
    result = addDays(new Date(), 1);
  }

  const timeToUse = getEventTimeOrDefault(time, defaultTime);
  let hours = getHoursAsNumber(timeToUse, true);
  hours = hours === undefined ? 9 : hours;

  let minutes = getMinutesAsNumber(timeToUse, true);
  minutes = minutes === undefined ? 0 : minutes;

  result = setHours(result, hours);
  result = setMinutes(result, minutes);
  result = setSeconds(result, 0);
  logger.trace(`getEventDateOrDefault(): time:=${time}, defaultTime:=${defaultTime} ->`, result);

  return result;
}
